const partnersAds = jQuery('.ad-bar')

if (partnersAds.length !== 0) {

    const partnersAdsCards = jQuery('.ad-bar li')

    const min = 1,
        max = partnersAdsCards.length,
        partnersAdsSelectedIndex = Math.floor(min + Math.random() * (max + 1 - min))

    jQuery(`.ad-bar li:eq(${partnersAdsSelectedIndex - 1})`).show()

}
